/*
 * @Description: 文件上传
 * @Author: shangao
 * @Date: 2022-04-28 11:21:46
 * @LastEditTime: 2022-05-06 20:19:44
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\components\Upload.jsx
 */
import axios from 'axios'
import { stringify } from 'qs'
import { Message } from 'element-ui'
import emitter from 'element-ui/src/mixins/emitter'
import uuid from '@/utils/uuid'
import { axiosFactory } from '@/services/axios-factory'
const cloneDeep = require('lodash.clonedeep')
import './upload.less'

// 常见accept配置

// const accept = {
//   title: '图片',
//   extensions: 'gif,jpg,jpeg,bmp,png',
//   mimeTypes: 'image/*'
// }

// const accept = {
//   title: '视频',
//   extensions: 'mp4,',
//   mimeTypes: 'video/*'
// }

const MUploadProps = {
  value: { type: Array },
  accept: { type: Object, default: null },
  fileNumLimit: { type: Number },
  listType: { type: String, default: 'text' },
  multiple: { type: Boolean, default: false }
}

// let uploader

const MUpload = {
  name: 'MUpload',
  model: { prop: 'value', event: 'change' },
  props: MUploadProps,
  mixins: [emitter],
  data () {
    return {
      uid: '',
      uploader: undefined,
      fileList: [],
      percentage: 0 // 上传进度百分比
    }
  },
  watch: {
    value (val) {
      this.fileList = cloneDeep(val)
      const found = this.fileList.find(item => item.status !== 'complete')
      // debugger
      console.log(JSON.parse(JSON.stringify(val)))
      if (!found) {
        this.dispatch('ElFormItem', 'el.form.change', val)
      }
    },
  },
  created () {
    this.uid = uuid()
  },
  mounted () {
    // console.log('dd')
    // this.uid = this.uuid()
    this.uploaderRegister()
    this.initUpload()
  },
  methods: {
    updateChane (file, response) {
      const info = {
        contextId: response.contextId,
        url: response.url,
        md5: response.md5,
        id: file.id,
        fileSize: file.size,
        fileName: file.name,
        status: file.status,
        percentage: file.percentage || 0
      }
      const index = this.fileList.findIndex(item => item.id === file.id)
      if (index === -1) {
        this.fileList.push(info)
      } else {
        this.fileList.splice(index, 1, info)
      }
      const list = JSON.parse(JSON.stringify(this.fileList))
      this.$emit('change', list)
    },
    // 初始化上传文件
    initUpload () {
      const { multiple, accept, fileNumLimit } = this.$props
      const { uid } = this.$data
      // 创建WebUploader实例
      this.uploader = WebUploader.create({
        compress: false, // 关闭图片压缩功能，否则会导致图片的MD5秒传功能失效
        timeout: 5 * 60 * 1000, // 超时时间设置为五分钟，不写默认为两分钟
        server: '',
        pick: {
          multiple,
          innerHTML: '上传',
          id: `#picker${uid}`
        },
        accept,
        fileNumLimit,

        // WebUploader插件原生设置项 —— END
        extension: {
          appName: 'edc', // * AppName，必需
          debug: true, // 关闭或打开日志开关，不写默认为打开
          thresholdSize: 10485760, // 10MB作为区分大、小文件的临界值，不写默认为10MB
          server: '' // * 文件服务地址，必需
        },

        // 回调方法
        callback: {
          getToken: this.getToken, // 获取上传文件所需Token
          cystorageCheck: this.cystorageCheck,
          cystorageChunk: this.cystorageChunk, // 分片上传
          storeFileInfo: function (file) {
            localStorage.setItem(file.md5, file.contextId)
          },
          delFileInfo: function (file) {
            localStorage.removeItem(file.md5)
          },
        }
      })

      console.log(this.uploader)
      this.bindEvent() // 绑定事件
    },
    uploaderRegister () {
      // const { uploader } = this.$data
      WebUploader.Uploader.unRegister('beforeSendFile')
      WebUploader.Uploader.unRegister('beforeSend')
      /** 
       * 1、区分大、小文件；
       * 2、计算文件MD5，获取Token；
       * 3、通过MD5判断文件是否已经存在；
       * 4、获取ContextID（仅大文件）；
       * 5、根据ContextID获取已经上传的分片；
       */
      WebUploader.Uploader.register({
        name: 'beforeSendFile',
        'before-send-file': function (file) {
          const task = WebUploader.Deferred()
          const { options, owner } = this
          // const { extension, callback } = options
          // console.log(options)
          // debugger
          owner.md5File(file.source)
            .progress(function (percentage) {
              console.log('md5Progress', percentage, file)
              // owner.trigger('md5Progress', percentage, file) // 触发MD5计算进度变更事件
            }).then((response) => {
              file.md5 = response
              owner.trigger('md5Complete', file)
              // debugger
              options.callback.cystorageCheck(file, task)
            })

          return task.promise()
        }
      })

      // 通过服务端返回的已上传分片信息进行断点续传的判断
      WebUploader.Uploader.register({
        name: 'beforeSend',
        'before-send': function (block) {
          return new Promise((resolve, reject) => {
            if (typeof block.file.currentFileChunksUploaded !== 'undefined' && block.file.currentFileChunksUploaded.length !== 0) {
              block.file.currentFileChunksUploaded.map((uploadedChunk) => {
                if (uploadedChunk.chunkNo === block.chunk) {
                  // reject() // 若在已上传分片的集合中含有当前分片的索引，则跳过该分片上传
                }
              })
              resolve()
            } else {
              // 找不到已经上传的分片信息，正常上传分片
              resolve()
            }
          })
        }
      })
    },
    // // 获取唯一标识
    // uuid () {
    //   const str = URL.createObjectURL(new Blob())
    //   return str.substring(str.length - 36)
    // },
    // 获取token
    getToken (file) {
      const { uploader } = this.$data
      return new Promise((resolve, reject) => {
        const url = '/file/getCystorageToken'
        const params = {
          fileExt: file.ext,
          chunks: file.chunks,
          md5: file.md5,
          contextId: file.contextId,
        }
        axiosFactory({ url, params }).then(({ data }) => {

          WebUploader.baseUrl = data.fileServerUrl.replace('http://', 'https://'); 
 
          file.md5Token = data.md5Token // ****** ↓ ******
          file.uploadToken = data.uploadToken // 此三项仅当ContextID不存在时返回
          file.prepareToken = data.prepareToken // ****** ↑ ******
          file.filePath = data.filePath
          file.chunkToken = data.chunkToken // ****** ↓ ******
          file.completeToken = data.completeToken // 此两项仅当ContextID存在时返回
          resolve(data)
        }).catch(error => {
          console.log('error: ', error)
          file.failed = true
          uploader.skipFile(file, 'error')
          uploader.trigger('uploadError', file, '获取token出错')
          reject(error)
        })
      })
    },
    // cystorage文件服务 - 判断文件在服务端是否已经存在
    cystorageCheck (file, task) {
      const { uploader } = this.$data
      const { extension, callback } = uploader.options
      // owner.trigger('md5Complete', file) // 触发MD5计算进度变更事件
      file.chunks = Math.ceil(file.size / uploader.options.chunkSize) // 计算文件分片数
      file.isLarge = file.size > extension.thresholdSize // 判断是否为大文件

      // 配合thresholdSize判断是否为大文件，实现分片／不分片上传接口的切换
      uploader.options.chunked = file.isLarge
      // chunk/upload(使用分片上传接口) /upload
      callback.getToken(file).then(function () {
        extension.appName = file.uploadToken.appKey
        extension.server = WebUploader.baseUrl
        uploader.options.server = `${WebUploader.baseUrl}/v2/files/${file.isLarge ? 'chunk/' : ''}upload`

        axios.get(`${WebUploader.baseUrl}/v2/files/check`, {
          withCredentials: false,
          params: file.md5Token,
        }).then(function (response) {
          if (response.data.md5 === file.md5) {
            file.exists = true
            uploader.skipFile(file)
            // debugger
            uploader.trigger('uploadSuccess', file, response.data)
            task.resolve()
          } else {
            if (file.isLarge) {
              callback.cystorageChunk(file, task)
            } else {
              task.resolve()
            }
          }
        }).catch(function () {
          // debugger
          // Bad Request说明服务端不存在相同文件，继续正常上传步骤
          if (file.isLarge) {
            callback.cystorageChunk(file, task)
          } else {
            task.resolve()
          }
        })
      })
    },

    // cystorage文件服务 - 大文件分片上传
    cystorageChunk (file, task) {
      const { uploader } = this.$data
      const { callback } = uploader.options
      // 如果ContextID不存在，则说明为第一次上传
      if (!file.contextId) {
        axios.post(`${WebUploader.baseUrl}/v2/files/prepare`, stringify(file.prepareToken), {
          withCredentials: false,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }).then(function (response) {
          // debugger
          file.contextId = response.data.contextId
          callback.getToken(file).then(function () {
            // 根据ContextID获取分片上传接口所需Token以及合并分片接口的Token
            WebUploader.Base.log('设置MD5对应的ContextID及ContextID对应的分片Token信息')
            callback.storeFileInfo(file) // 储存断点续传所需的相关信息（contextId、chunkToken、completeToken）
            task.resolve()
          })
        }).catch(function (response) {
          // debugger
          file.failed = true
          uploader.skipFile(file, 'error')
          uploader.trigger('uploadError', file, '获取预上传ContextID出错；服务端返回信息：' + JSON.stringify(response))
          task.resolve()
        })
      } else {
        // callback.fetchFileInfo(file).then(function () {
        // 如果不是第一次上传，则将第一次上传的相关信息取出，以便通过之前的ContextID获取上传进度，进行断点续传
        // 通过ContextID获取已经上传的分片
        axios.get(`${WebUploader.baseUrl}/v2/files/${file.contextId}/getchunks`, {
          withCredentials: false,
          params: file.md5Token,
        }).then(function (response) {
          WebUploader.Base.log('通过ContextID获取已经上传的分片')
          file.currentFileChunksUploaded = response.data.chunkInfoList
          callback.getToken(file).then(function () {
            task.resolve()
          })
        }).catch(function () {
          WebUploader.Base.log('获取已上传分片信息时出现错误，尝试重新上传文件')
          task.resolve()
        })
      }
    },

    // ystorage文件服务- 大文件合并已经上传的分片
    cystorageComplete (file) {
      const { uploader } = this.$data
      const { callback } = uploader.options
      axios.post(`${WebUploader.baseUrl}/v2/files/complete`, stringify(file.completeToken), {
        withCredentials: false,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then((data) => {
        console.log('data：', data)
        file.percentage = 100
        // debugger
        this.updateChane(file, data.data)
        callback.delFileInfo(file)
      }).catch(function (response) {
        file.failed = true
        uploader.skipFile(file, 'error')
        uploader.trigger('uploadError', file, '合并分片时发生错误；服务端返回信息：' + JSON.stringify(response))
      })
    },

    // 绑定事件
    bindEvent () {
      const { uploader } = this.$data
      // 当文件被加入队列以后触发
      uploader.on('fileQueued', (file) => {
        // file.status = 'uploading'
        file.status = file.getStatus()
        // debugger
        console.log(file.status)
        this.updateChane(file, {})
        uploader.upload()
      })

      // 当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数
      uploader.on('uploadBeforeSend', function (object, data) {
        // debugger
        // 如果文件已经存在，则不需要触发上传操作
        if (!object.file.exists) {
          // 设置上传参数
          data.appKey = this.options.extension.appName

          if (object.file.isLarge) {
            data.chunk = object.chunk
            data.expires = object.file.chunkToken[object.chunk].expires
            data.token = object.file.chunkToken[object.chunk].token
            data.contextId = object.file.chunkToken[object.chunk].contextId
          } else {
            data.filePath = object.file.uploadToken.filePath
            data.token = object.file.uploadToken.token
            data.expires = object.file.uploadToken.expires
            data.appKey = object.file.uploadToken.appKey
          }

          // 删除无用属性，否则调用cystorage接口会返回失败
          delete data.chunks
          delete data.lastModifiedDate
          delete data.id
          delete data.name
          delete data.type
          delete data.size
        }
      })

      uploader.on('md5Complete', (file) => {
        // _this.file = file;
        // debugger
        file.status = file.getStatus()
        console.log(file.status)
        // const ind = parseInt(_this.uid.replace('myupload', '')) - 1
        // _this.$emit('md5Complete', file, ind)
      })

      // 当文件上传成功时触发
      uploader.on('uploadSuccess', (file, response) => {
        // file.status = file.getStatus()
        const wFile = uploader.getFile(file.id)
        if (wFile) {
          file.status = file.getStatus()
        }
        // debugger
        if (!response) return
        if (file.isLarge) {
          if (file.exists) {
            this.updateChane(file, response)
            return
          }
          this.cystorageComplete(file)
        } else {
          // debugger
          file.percentage = 100
          this.updateChane(file, response)
        }
      })

      // 当文件的上传进度变化时
      uploader.on('uploadProgress', (file, percentage) => {
        const found = this.fileList.find(item => item.id === file.id)
        console.log(file.status)
        if (found) {
          found.status = file.getStatus()
          found.percentage = Math.floor(percentage * 99)
          console.log(found.percentage)
        }
        // debugger
        // console.log(file.id, Math.floor(percentage * 99))
      })
      // uploader.onUploadProgress = (file, percentage) => {
      //   console.log(file.id, Math.floor(percentage * 99))
      //   // const ind = parseInt(_this.uid.replace('myupload', '')) - 1
      //   // _this.$emit('changePercentage', file.id, Math.floor(percentage * 99), ind)
      // }

      // 当文件上传出错时触发
      uploader.on('uploadError', () => {
        console.log('uploadError')
        uploader.reset()
      })

      uploader.on('error', (type) => {
        let message
        switch (type) {
          case 'F_DUPLICATE':
            message = '不允许上传相同文件！'
            break
          case 'Q_TYPE_DENIED':
            message = '不支持上传该类型文件！'
            break
          case 'Q_EXCEED_NUM_LIMIT':
            message = '超出允许上传文件数量'
            break
          default:
            message = type
            break
        }

        Message.error(message)
      })
    },

    // 开始上传
    upload (fileId) {
      // const file = uploader.getFile(fileId)
      this.uploader.upload()
    },
    // 暂停上传
    stop (fileId) {
      // const file = uploader.getFile(fileId)
      // debugger
      this.uploader.stop()
      // debugger
    },

    // 删除文件
    handleDelete (file) {
      const list = this.fileList.filter(item => item.id !== file.id)
      // 从上传队列中删除文件
      // debugger
      if (file.id && file.id.includes('WU_FILE')) {
        // debugger
        this.uploader.removeFile(file.id, true)
      }
      this.fileList = cloneDeep(list)
      this.$emit('change', list)
    }
  },
  render () {
    const { listType, fileNumLimit } = this.$props
    const { uid, fileList } = this.$data
    const showBtn = fileNumLimit === undefined || fileList.length < fileNumLimit
    // console.log(showBtn)
    const renderItem = (item) => {
      const progress = (item.percentage === 100 || item.status === 'complete') ? null : <el-progress percentage={item.percentage}></el-progress>

      const listText = (
        <div class="item-info">
          <div class="item-name" title={item.fileName}>{item.fileName}</div>
          <span class="item-actions">
            {/* {item.status === 'progress' ? <i class="el-icon-video-pause" onClick={() => this.stop(item.id)}></i> : null} */}
            {/* {item.status === 'interrupt' ? <i class="el-icon-video-play" onClick={() => this.upload(item.id)}></i> : null} */}
            {
              item.status == 'complete'
                ? <i class="el-icon-delete" onClick={() => this.handleDelete(item)}></i>
                : <i style="font-size: 12px;font-style:normal;color: #999">请等待文件上传...</i>
            }
          </span>
        </div>
      )

      const listPicture = (
        <div class="picture-item">
          <el-image style="width: 110px; height: 110px" src={item.url} fit="cover"></el-image>
          <span class="item-actions">
            <i class="el-icon-delete" onClick={() => this.handleDelete(item)}></i>
          </span>
        </div>
      )
      const itemClass = `list-item ${item.status}`
      return (
        <div class={itemClass}>
          {
            listType === 'text'
              ? listText
              : listType === 'picture'
                ? listPicture
                : null
          }
          {progress}
        </div>
      )
    }
    return (
      <div class="m-upload">
        <div id={`picker${uid}`} class={`picker ${showBtn ? '' : 'picker-hide'}`} >选择文件</div>
        <div class={`file-list list-${listType}`}>{fileList.map(item => renderItem(item))}</div>
      </div>
    )
  }
}

export default MUpload